import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { createHead } from '@unhead/vue/client';

import { useAuthStore } from '@/stores/auth';
import router from '@/router';
import App from '@/layouts/App.vue';
import * as Sentry from "@sentry/vue";

import axios from 'axios';
import i18n from '@/plugins/i18n';

window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['Content-Type'] = 'application/json';
window.axios.defaults.headers.common['Accept'] = 'application/json';
window.axios.defaults.withCredentials = true;
window.axios.defaults.withXSRFToken = true;

const pinia = createPinia();
const head = createHead();

const app = createApp(App)
    .use(pinia)
    .use(head)
    .use(i18n);

const authStore = useAuthStore();
authStore.attempt_user()
    .then(() => {
        setLocale(authStore.currentLocale);
    })
    .catch(() => setLocale(authStore.currentLocale))
    .finally(() => {
        app.use(router)
            .mount('#app');
    });

function setLocale(locale: string) {
    document.documentElement.setAttribute('lang', locale);
    i18n.global.locale.value = locale as 'en' | 'nl';
}

if (import.meta.env.VITE_SENTRY_DSN) {
    Sentry.init({
        app,
        dsn: import.meta.env.VITE_SENTRY_DSN,
        integrations: [
            Sentry.browserTracingIntegration({ router }),
            Sentry.replayIntegration(),
        ],
        tracesSampleRate: 1.0,
        tracePropagationTargets: ['localhost'],
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
    });
}
